import {Modal} from "react-bootstrap";
import {TruckInfo} from "./NewEditTruckModal";
import {formatStandardizedAddress, splitAddressIntoStreetAndCityStateZip} from "../../shared/sharedFunctions";
import {useEffect, useState} from "react";

interface LinkCCModalProps {
    show: boolean;
    toggle: () => void;
    onSubmit: (data: any) => void;
    allAddresses: any;
    currentCustomerId: number;
}

const LinkCCModal: React.FC<LinkCCModalProps> = ({show, toggle, allAddresses, currentCustomerId, onSubmit}) => {
    const [selectedAddressIds, setSelectedAddressIds] = useState<number[]>([]);
    useEffect(() => {
        if (allAddresses) {
            setSelectedAddressIds(allAddresses.map(add => add.customerId));
        }
    }, [allAddresses]);
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header className="modal-header">
                <h4 className="modal-title" id="exampleModalLabel">Update billing for linked addresses?</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </Modal.Header>
            <Modal.Body className="p-4">
                <h4 className="mb-4"><i className="fa-solid fa-link text-secondary"></i> {allAddresses?.length} Addresses Linked</h4>
                <form className="m-1">
                    {allAddresses?.map((add, index) => {
                        const [street, city] = splitAddressIntoStreetAndCityStateZip(formatStandardizedAddress(add));
                        const isChecked = selectedAddressIds.includes(add.customerId);

                        const handleChange = () => {
                            setSelectedAddressIds(prev =>
                                isChecked
                                    ? prev.filter(id => id !== add.customerId)
                                    : [...prev, add.customerId]
                            );
                        };

                        return (
                            <div className="form-check mb-3" key={add.customerId}>
                                <input
                                    className="form-check-input form-check-input-md"
                                    type="checkbox"
                                    id={`linkedAddress-${index}`}
                                    checked={isChecked}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label lh-sm ms-2 d-block" htmlFor={`linkedAddress-${index}`}>
                                    {street}<br />{city}
                                </label>
                                {add.customerId === currentCustomerId &&
                                    <span className="badge rounded-pill bg-lightblue text-body ms-2 mt-1">currently viewing</span>}
                            </div>
                        );
                    })}
                </form>
            </Modal.Body>
            <div className="modal-footer">
                <button onClick={() => onSubmit([currentCustomerId])} type="button" className="btn btn-light text-strong m-100" data-bs-dismiss="modal">No thanks</button>
                <button onClick={() => onSubmit(selectedAddressIds)} type="button" className="btn btn-primary text-strong m-100" data-bs-dismiss="modal" aria-label="Update">Update</button>
            </div>
        </Modal>
    );
}
export default LinkCCModal;
